// extracted by mini-css-extract-plugin
export default {"Emoji":"bbg_a bhh_i bhh_q bhh_j"};